import React from 'react'

import { Box, Card, CardContent, CardHeader } from '@mui/material'
import { useParams } from 'react-router-dom'

import { Table } from 'components/table'
import { useCampaignAds, useUpdateAdStatus } from 'hooks/useCampaignAds'
import { usePaginatedTableMeta } from 'hooks/usePaginatedTableMeta'

import CampaignAdActionButton from './CampaignAdActionButton'

const CampaignAds = () => {
  const { id } = useParams()
  const { meta, setPage, setRowsPerPage, setSort } = usePaginatedTableMeta({
    rowsPerPage: 5,
    sortBy: '',
    sortOrder: '',
  })
  const { data, isLoading, error } = useCampaignAds(id, meta)
  const updateAdStatus = useUpdateAdStatus()

  const handleStatusChange = (p: any) => updateAdStatus.mutate({ campaignId: id, ad: p })
  const handleSort = (property: any) => () => setSort(property)

  const config = [
    {
      title: 'Name',
      render: ({ name }: any) => (
        <Box sx={{ overflowWrap: 'anywhere' }}>
          <span>{name}</span>
        </Box>
      ),
      sort: 'name',
    },
    { title: 'Views', field: 'views', sort: 'views', headerStyle: { width: '80px' } },
    { title: 'Clicks', field: 'clicks', sort: 'clicks', headerStyle: { width: '80px' } },
    { title: 'CTR', render: (data: any) => `${data.ctr.toFixed(2)}%`, sort: 'ctr', headerStyle: { width: '40px' } },
    { title: 'Share', render: (data: any) => `${data.share}%`, sort: 'share', headerStyle: { width: '40px' } },
    {
      title: 'Status',
      render: (data: any) => `${data.is_running ? 'RUNNING' : 'PAUSED'}`,
      sort: 'is_running',
      headerStyle: { width: '60px' },
    },
    {
      title: 'Action',
      headerStyle: { width: '40px' },
      render: (data: any) => <CampaignAdActionButton ad={data} onStatusChange={handleStatusChange} />,
    },
  ]

  return (
    <Card>
      <CardHeader title="Ads" />
      <CardContent>
        <Box sx={{ width: '100%' }}>
          <Table
            config={config}
            count={data?.count}
            data={data?.items}
            error={error ? 'Error occurred when loading campaign ads data' : undefined}
            loading={isLoading}
            onChangePage={setPage}
            onChangeRowsPerPage={setRowsPerPage}
            onSort={handleSort}
            page={meta.page}
            rowsPerPage={meta.rowsPerPage}
            sortBy={meta.sortBy}
            sortOrder={meta.sortOrder}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default CampaignAds
